module.exports = {"label":{"calls":"Popis poziva","resources":"Status sustava"}}